import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>VK-React filter</h1>
			<p className='project-popup__description '>
				It's essential to have only active members in your VK groups; otherwise, the
				administration of VK (algorithms) could think that your communities violate
				the website's rules. I built the application with React.js on the VK
				NativeApps platform (Iframe apps), using VK Javascript SDK and VKUI
				Styleguide to give it a well-looking VK appearance. <br />
				Primarily, it is a client-side app, but I needed to add the server part only
				for removing blocked&deleted users as VK-API doesn't allow us to do it with
				NativeIframeApp's access_token.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						React.js, VK Javascript SDK for Native apps, VKUI Styleguide, Node.js +
						express
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/m_johvEPhI0'
					title='VK Filter app (React.js + Node.js)'
				/>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='https://github.com/Slava-Nik/React-vk-dogs-scanner'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Source code
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
